import { useEffect } from "react";

const SITE_NAME = "Puntogomme Lazio";
const DEFAULT_DESCRIPTION = "Pneumatici, meccanica e revisioni nel Lazio. Vendita online, cambio gomme, 5 punti vendita: Monterotondo, Roma Tiburtina, Mentana, Ponte Galeria, Trastevere.";
const FALLBACK_SITE_URL = "https://www.puntogommelazio.it";

function getSiteUrl() {
  if (typeof window !== "undefined") return window.location.origin;
  return process.env.REACT_APP_SITE_URL || FALLBACK_SITE_URL;
}

const SITE_URL = FALLBACK_SITE_URL;

function setMeta(name, content, attr = "name") {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Componente per meta tag SEO e Open Graph (senza dipendenze esterne, compatibile con React 19).
 * @param {string} title - Titolo pagina (viene suffissato con " | Puntogomme Lazio")
 * @param {string} description - Meta description
 * @param {string} canonical - URL canonico (path relativo, es. "/prodotti")
 * @param {boolean} noindex - Se true imposta noindex
 * @param {object} jsonLd - Oggetto JSON-LD da iniettare (Organization, LocalBusiness, ItemList, ecc.)
 */
export default function Seo({ title, description = DEFAULT_DESCRIPTION, canonical, noindex = false, jsonLd }) {
  useEffect(() => {
    const baseUrl = getSiteUrl();
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - Pneumatici, meccanica e revisioni`;
    const canonicalUrl = canonical ? (canonical.startsWith("http") ? canonical : `${baseUrl}${canonical.startsWith("/") ? "" : "/"}${canonical}`) : null;

    document.title = fullTitle;
    setMeta("description", description);
    if (canonicalUrl) setLink("canonical", canonicalUrl);
    if (noindex) setMeta("robots", "noindex, nofollow");
    else setMeta("robots", "index, follow");

    setMeta("og:type", "website", "property");
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", description, "property");
    setMeta("og:url", canonicalUrl || baseUrl, "property");
    setMeta("og:locale", "it_IT", "property");
    setMeta("og:site_name", SITE_NAME, "property");
  }, [title, description, canonical, noindex]);

  useEffect(() => {
    if (!jsonLd) return;
    const id = "seo-json-ld";
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    const script = document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [jsonLd]);

  return null;
}

export { SITE_NAME, DEFAULT_DESCRIPTION, SITE_URL, getSiteUrl };
